export default {
	rightMenusShadows: '-4px 4px 10px 0px rgba(0, 0, 0, 0.1)'
}
